import { render } from "./WaybillForm.vue?vue&type=template&id=3e9528c8&scoped=true"
import script from "./WaybillForm.vue?vue&type=script&lang=js"
export * from "./WaybillForm.vue?vue&type=script&lang=js"

import "./WaybillForm.vue?vue&type=style&index=0&id=3e9528c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e9528c8"]])

export default __exports__